module.exports = __webpack_public_path__ + "d2aaea9c7aa4a50d7bb0303e248176ba.jpg";